import { gql } from "./__generated__/gql";

export const GET_DEPARTMENT_CATEGORIES = gql(`
  query GetDepartmentCategories($departmentId: Int!, $orderNumber: String) {
    departmentCategories(departmentId: $departmentId, orderNumber: $orderNumber) {
      categories {
        id
        identifier
        productCategory
        displayName
        isNew
        isDeactivated
        isRetired
        planOfCareFields {
          id
          display
          columnName
          required
          visibleInSummary
        }
        categoryDiagnosisTypes {
          id
          categoryId
          diagnosisType {
            id
            type
            diagnosisFields {
              id
              display
              columnName
            }
          }
          numberOfCustomDiagnosis
        }
        defaultIcd10Descriptions {
          id
          code
          description
        }
        subcategories {
          id
          name
          formItems {
            id
            name
            popularity
            lineItemFields {
              id
              display
              columnName
            }
            optionGroups {
              id
              name
              required
              options {
                id
                name
                deletedAt
              }
            }
            variants {
              id
              quantity
              formItemOptionIds
            }
          }
        }
      }
    }
  }
`);

export const GET_DEPARTMENT = gql(`
  query Department($departmentId: Int!) {
    department(departmentId: $departmentId) {
      id
      name
      typeId
      typeName
      hospitalId
      hospitalName
      hospitalUsageType
      hospitalTimezone
      hospitalSystem {
        id
        name
        sharedPatients
      }
      faxNotificationsEnabled
      aiExtractionEnabled
      createdAt
      address1
      address2
      city
      stateAbbr
      zipcode
      isHomeHealth
      hospitalPhoneNumber
      allowSignersWithoutFaxNumbers
      cpapFormEnabled
      isZingPreferred
      miscellaneousFormEnabled
      ostomyFormEnabled
      urologyFormEnabled
    }
  }
`);
